import { render, staticRenderFns } from "./addNewQueryModal.vue?vue&type=template&id=1f07607c&scoped=true"
import script from "./addNewQueryModal.vue?vue&type=script&lang=js"
export * from "./addNewQueryModal.vue?vue&type=script&lang=js"
import style0 from "./addNewQueryModal.vue?vue&type=style&index=0&id=1f07607c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07607c",
  null
  
)

export default component.exports